module.exports = "../images/logo-typography-black.svg";